import { useCallback } from "react";
import { toast } from "react-toastify";
import { useFilterContext } from "@app/network-portfolio-management/contexts/FilterContext";
import { SavedView } from "@app/network-portfolio-management/interfaces";

export function useSaveViewHandler(): (view: SavedView, replacedId?: number) => void {
  const { addView, replaceView } = useFilterContext();

  return useCallback((view: SavedView, replacedId?: number) => {
    if (replacedId !== undefined) {
      replaceView(replacedId, view, true);
    } else {
      addView(view);
    }
    toast.success("View saved", { containerId: "z-index-9999" });
  }, [addView, replaceView]);
}
